import { FillFactory } from './fill.factory';
import { TradeDto } from '../dto';
import { Token, Trade } from '../model';

export class TradeFactory {
  public static createFromDto(dto: TradeDto, from: Token, to: Token): Trade {
    const trade = new Trade();
    if (dto) {
      trade.id = dto.id;
      trade.fromAmount = BigInt(dto.fromAmount);
      trade.toAmount = BigInt(dto.toAmount);
      trade.toValueInNative = dto.toValueInNative
        ? BigInt(dto.toValueInNative)
        : undefined;
      trade.fromValueInUsd = dto.fromValueInUsd;
      trade.toValueInUsd = dto.toValueInUsd;
      trade.fromDecimals = dto.from.decimals;
      trade.toDecimals = dto.to.decimals;
      trade.minToReceive = BigInt(dto.minToReceive);
      trade.minToReceiveInUsd = dto.minToReceiveInUsd;
      trade.previouslyRequiredTrades = dto.previouslyRequiredTrades;
      trade.txHandler = dto.txHandler;
      trade.txData = dto.txData;
      trade.estimatedFees = BigInt(dto.estimatedFees);
      trade.estimatedPriceImpact = dto.estimatedPriceImpact;
      trade.allowanceTarget = dto.allowanceTarget;
      trade.price = dto.price;
      trade.guaranteedPrice = dto.guaranteedPrice;
      trade.state = dto.state;
      trade.transactions = dto.transactions;
      trade.rfqt = dto.rfqt;
      if (dto.fill) {
        trade.fill = FillFactory.createFromDto(dto.fill);
      }
      trade.tradeInfos = dto.tradeInfos;
      if (dto.expirationTimestamp) {
        trade.expirationTimestamp = new Date(dto.expirationTimestamp);
      }
    }
    trade.from = from;
    trade.to = to;

    return trade;
  }
}
